import { $t } from '@monorepo/utils';

type RouteTitleGetter = () => string;

interface RouteLike {
  name?: string;
  path?: string | string[];
  microApp?: string;
}

export const HOME_PAGE_NAME = { id: 'HOME_PAGE_NAME', defaultMessage: '首页' };

// 同一个 route.name 可能对应不同页签文案，这里用 `${name}@${path}` 做更精确的覆盖。
// 普通路由优先维护在 routeTitleByName，只有存在同名不同文案时才需要放到这里。
const routeTitleByNameAndPath: Record<string, RouteTitleGetter> = {
  'main-operations-goods-timePeriodMenu@/main-operations/goods/timePeriodMenu/clearStore': () =>
    $t({ defaultMessage: '清空门店时段菜单' }),
  'main-operations-QRCodeManagement@/main-operations/QRCodeManagement': () =>
    $t({ defaultMessage: '二维码管理' }),
  'main-operations-QRCodeManagement@/main-operations/QRCodeManagement/emptyQRCode': () =>
    $t({ defaultMessage: '制作空码' }),
  'main-operations-QRCodeManagement@/main-operations/QRCodeManagement/tableQRCode': () =>
    $t({ defaultMessage: '桌台点餐码' }),
  'main-serviceMarket-MTOrderApiCall@/main-serviceMarket/settings/valueAdd/buyMTOrder/:id': () =>
    $t({ defaultMessage: '外卖平台API调用' }),
  'main-serviceMarket-MTOrderApiCall@/main-serviceMarket/settings/valueAdd/buyMTOrderDetail/:id':
    () => $t({ defaultMessage: '外卖平台API调用' }),
  'main-serviceMarket-MTOrderApiCall@/main-serviceMarket/settings/valueAdd/buyPlatform': () =>
    $t({ defaultMessage: '平台小程序调用' }),
  'main-serviceMarket-MTOrderApiCall@/main-serviceMarket/settings/valueAdd/buyPlatformDetail': () =>
    $t({ defaultMessage: '平台小程序调用' }),
  'main-serviceMarket-MTOrderApiCall@/main-serviceMarket/settings/valueAdd/MTOrderApiCall/:id':
    () => $t({ defaultMessage: '外卖平台API调用' }),
  'main-serviceMarket-MTOrderApiCall@/main-serviceMarket/settings/valueAdd/platformProgramCall':
    () => $t({ defaultMessage: '平台小程序调用' }),
  'stock-order-distributionCenter@/orders/distributionCenter': () =>
    $t({ defaultMessage: '配送中心' }),
  'stock-order-distributionCenter@/orders/distributionCenter/guide': () =>
    $t({ defaultMessage: '配送中心' }),
  'stock-order-distributionCenter@/orders/distributionCenter/purchase': () =>
    $t({ defaultMessage: '配送中心-生成采购单' }),
  'stock-process-goodsFormula@/process/goodsFormula': () => $t({ defaultMessage: '配方管理' }),
  'stock-process-goodsFormula@/process/goodsFormula/copy/:copyId/:activekey/:locationItem': () =>
    $t({ defaultMessage: '配方管理' }),
  'stock-process-goodsFormula@/process/goodsFormula/edit/:id/:activekey/:locationItem': () =>
    $t({ defaultMessage: '配方管理' }),
  'stock-process-goodsFormula@/process/goodsFormula/issueManage': () =>
    $t({ defaultMessage: '配方管理' }),
  'stock-process-goodsFormula@/process/goodsFormula/new': () => $t({ defaultMessage: '配方管理' }),
  'stock-process-goodsFormula@/process/goodsFormula/read/:id/:activekey/:type': () =>
    $t({ defaultMessage: '配方管理' }),
  'stock-process-goodsFormula@/process/processProducts': () => $t({ defaultMessage: '加工品管理' }),
};

const routeTitleByName: Record<string, RouteTitleGetter> = {
  customDownload: () => $t({ defaultMessage: '客户端下载' }),
  'customer-wholesales-report': () => $t({ defaultMessage: '客户销售报表' }),
  decorateContentManage: () => $t({ defaultMessage: '店铺装修' }),
  decorateCustomLoading: () => $t({ defaultMessage: '店铺装修' }),
  decorateShoppageAppletPage: () => $t({ defaultMessage: '店铺装修' }),
  decorateShoppageBootPage: () => $t({ defaultMessage: '店铺装修' }),
  decorateShoppageCollectStamp: () => $t({ defaultMessage: '店铺装修' }),
  decorateShoppageCopyrightLogo: () => $t({ defaultMessage: '店铺装修' }),
  decorateShoppageCustomerCount: () => $t({ defaultMessage: '店铺装修' }),
  decorateShoppageCustomizPageEditor: () => $t({ defaultMessage: '店铺装修' }),
  decorateShoppageCustomPage: () => $t({ defaultMessage: '店铺装修' }),
  decorateShoppageDineOrder: () => $t({ defaultMessage: '店铺装修' }),
  decorateShoppageFloatingWindows: () => $t({ defaultMessage: '店铺装修' }),
  decorateShoppageGetDiscountActivity: () => $t({ defaultMessage: '店铺装修' }),
  decorateShoppageGiftCards: () => $t({ defaultMessage: '店铺装修' }),
  decorateShoppageGiftLuckyDrawPage: () => $t({ defaultMessage: '店铺装修' }),
  decorateShoppageGoodsPage: () => $t({ defaultMessage: '店铺装修' }),
  decorateShoppageGoodsPageEditor: () => $t({ defaultMessage: '店铺装修' }),
  decorateShoppageLimitedDiscountPage: () => $t({ defaultMessage: '店铺装修' }),
  decorateShoppageListPage: () => $t({ defaultMessage: '店铺装修' }),
  decorateShoppageListPageEditor: () => $t({ defaultMessage: '店铺装修' }),
  decorateShoppageMallPage: () => $t({ defaultMessage: '店铺装修' }),
  decorateShoppageMemberStoredValue: () => $t({ defaultMessage: '店铺装修' }),
  decorateShoppageMerchantPage: () => $t({ defaultMessage: '店铺装修' }),
  decorateShoppageMerchantPageEditor: () => $t({ defaultMessage: '店铺装修' }),
  decorateShoppageOrderConfirm: () => $t({ defaultMessage: '店铺装修' }),
  decorateShoppageOrderDetail: () => $t({ defaultMessage: '店铺装修' }),
  decorateShoppageOrderList: () => $t({ defaultMessage: '店铺装修' }),
  decorateShoppageOrderSuccess: () => $t({ defaultMessage: '店铺装修' }),
  decorateShoppagePackagePage: () => $t({ defaultMessage: '店铺装修' }),
  decorateShoppagePointShops: () => $t({ defaultMessage: '店铺装修' }),
  decorateShoppageProductPreOrder: () => $t({ defaultMessage: '店铺装修' }),
  decorateShoppageReceiveCouponCenter: () => $t({ defaultMessage: '店铺装修' }),
  decorateShoppageScanCode: () => $t({ defaultMessage: '店铺装修' }),
  decorateShoppageSearchPages: () => $t({ defaultMessage: '店铺装修' }),
  decorateShoppageSharePage: () => $t({ defaultMessage: '店铺装修' }),
  decorateShoppageSortpage: () => $t({ defaultMessage: '店铺装修' }),
  decorateShoppageSortpageEditor: () => $t({ defaultMessage: '店铺装修' }),
  decorateShoppageStoreNavigationPage: () => $t({ defaultMessage: '店铺装修' }),
  decorateShoppageSystemStyle: () => $t({ defaultMessage: '店铺装修' }),
  decorateShoppageUserCenterPage: () => $t({ defaultMessage: '店铺装修' }),
  decorateShoppageUserCenterPageEditor: () => $t({ defaultMessage: '店铺装修' }),
  'distribution-manager-report': () => $t({ defaultMessage: '配送报表' }),
  'finance-manager-report': () => $t({ defaultMessage: '财务报表' }),
  home: () => $t(HOME_PAGE_NAME),
  'inventory-manager-report': () => $t({ defaultMessage: '库存报表' }),
  'main-account-security': () => $t({ defaultMessage: '安全性' }),
  'main-account-userInfo': () => $t({ defaultMessage: '个人信息' }),
  'main-base-invoice-apply': () => $t({ defaultMessage: '开票申请' }),
  'main-base-invoice-locations': () => $t({ defaultMessage: '开票门店' }),
  'main-base-invoice-management': () => $t({ defaultMessage: '开票商户' }),
  'main-base-invoice-record': () => $t({ defaultMessage: '开票记录' }),
  'main-base-invoice-setup': () => $t({ defaultMessage: '开票设置' }),
  'main-finance-appletPayRecord': () => $t({ defaultMessage: '支付记录' }),
  'main-finance-appletPayRefund': () => $t({ defaultMessage: '退款记录' }),
  'main-finance-appletPayTrade': () => $t({ defaultMessage: '交易汇总' }),
  'main-finance-capitalFlow': () => $t({ defaultMessage: '资金流水' }),
  'main-finance-channelConfig': () => $t({ defaultMessage: '渠道配置' }),
  'main-finance-customLedger': () => $t({ defaultMessage: '自定义分账方案' }),
  'main-finance-fundParams': () => $t({ defaultMessage: '资金参数' }),
  'main-finance-customSettlementForm': () => $t({ defaultMessage: '自定义分账结算单' }),
  'main-finance-dashboard': () => $t({ defaultMessage: '数据概览' }),
  'main-finance-distributionAudit': () => $t({ defaultMessage: '分账稽查' }),
  'main-finance-financeCenter': () => $t({ defaultMessage: '订单支付' }),
  'main-finance-financialEntity': () => $t({ defaultMessage: '财务主体' }),
  'main-finance-financialEntityChangeRecord': () => $t({ defaultMessage: '财务主体变更记录' }),
  'main-finance-giftCardConsumptionLedger': () => $t({ defaultMessage: '礼品卡消费分账方案' }),
  'main-finance-giftCardConsumptionSettlementForm': () =>
    $t({ defaultMessage: '礼品卡消费分账结算单' }),
  'main-finance-headquartersExpense': () => $t({ defaultMessage: '总部费用单' }),
  'main-finance-headquartersLedger': () => $t({ defaultMessage: '总部分账方案' }),
  'main-finance-headquartersSettlementForm': () => $t({ defaultMessage: '总部分账结算单' }),
  'main-finance-location-sub-merchant-config': () => $t({ defaultMessage: '门店子商户配置' }),
  'main-finance-locationExpense': () => $t({ defaultMessage: '门店费用单' }),
  'main-finance-locationFinanceSetting': () => $t({ defaultMessage: '门店财务设置' }),
  'main-finance-locationLedger': () => $t({ defaultMessage: '门店分账方案' }),
  'main-finance-locationSettlementForm': () => $t({ defaultMessage: '门店分账结算单' }),
  'main-finance-moneySetting': () => $t({ defaultMessage: '款项设置' }),
  'main-finance-myApp': () => $t({ defaultMessage: '我的应用' }),
  'main-finance-myMerchant': () => $t({ defaultMessage: '我的商户' }),
  'main-finance-paymentRecords': () => $t({ defaultMessage: '付款记录' }),
  'main-finance-paymentRecordSummary': () => $t({ defaultMessage: '付款记录汇总' }),
  'main-finance-payRecord': () => $t({ defaultMessage: '支付记录' }),
  'main-finance-payRefund': () => $t({ defaultMessage: '退款记录' }),
  'main-finance-payTrade': () => $t({ defaultMessage: '交易汇总' }),
  'main-finance-recordAccountFlow': () => $t({ defaultMessage: '记账户流水' }),
  'main-finance-settlementOrder': () => $t({ defaultMessage: '分账明细' }),
  'main-finance-storedValueConsumptionLedger': () => $t({ defaultMessage: '储值消费分账方案' }),
  'main-finance-storedValueConsumptionSettlementForm': () =>
    $t({ defaultMessage: '储值消费分账结算单' }),
  'main-finance-streamSummary': () => $t({ defaultMessage: '流水汇总' }),
  'main-finance-summaryOfFlow': () => $t({ defaultMessage: '流水明细' }),
  'main-finance-voucherVerificationLedger': () => $t({ defaultMessage: '券核销分账方案' }),
  'main-finance-voucherVerificationSettlementForm': () =>
    $t({ defaultMessage: '券核销分账结算单' }),
  'main-finance-withdrawalRecords': () => $t({ defaultMessage: '提现记录' }),
  'main-message': () => $t({ defaultMessage: '消息中心' }),
  'main-operations-abnormalOrders': () => $t({ defaultMessage: '异常订单' }),
  'main-operations-accountManagement': () => $t({ defaultMessage: '企业挂账管理' }),
  'main-operations-advertisingList': () => $t({ defaultMessage: '广告管理' }),
  'main-operations-afterSaleOrders': () => $t({ defaultMessage: '售后订单' }),
  'main-operations-aggregatedDelivery': () => $t({ defaultMessage: '聚合配送' }),
  'main-operations-anyChoice': () => $t({ defaultMessage: 'N元任选' }),
  'main-operations-billScanningCode': () => $t({ defaultMessage: '扫码买单' }),
  'main-operations-brandName': () => $t({ defaultMessage: '品牌管理' }),
  'main-operations-businessSettings': () => $t({ defaultMessage: '手机点餐设置' }),
  'main-operations-cake-decorator': () => $t({ defaultMessage: '裱花网络' }),
  'main-operations-callNumberSetting': () => $t({ defaultMessage: '叫号设置' }),
  'main-operations-cardCouponAfterSalesOrders': () => $t({ defaultMessage: '卡券售后订单' }),
  'main-operations-cardImport': () => $t({ defaultMessage: 'IC卡导入' }),
  'main-operations-cardKind': () => $t({ defaultMessage: '会员卡类型' }),
  'main-operations-cardorders': () => $t({ defaultMessage: '卡券订单' }),
  'main-operations-cashierRules': () => $t({ defaultMessage: '收银打印配置' }),
  'main-operations-channelFlow-douyin-memberPass': () => $t({ defaultMessage: '抖音会员通' }),
  'main-operations-channelFlow-earth-memberPass': () => window.$t({ defaultMessage: '零售会员通' }),
  'main-operations-cloud-speaker-group': () => $t({ defaultMessage: '设备分组管理' }),
  'main-operations-cloud-speaker-management': () => $t({ defaultMessage: '云音响管理' }),
  'main-operations-cloud-speaker-rule': () => $t({ defaultMessage: '语音播报规则' }),
  'main-operations-clubCard': () => $t({ defaultMessage: '会员卡列表' }),
  'main-operations-clubCardGroup': () => $t({ defaultMessage: '会员卡共享分组' }),
  'main-operations-collectCard': () => $t({ defaultMessage: '注册有礼' }),
  'main-operations-collectStampList': () => $t({ defaultMessage: '集点卡' }),
  'main-operations-commentsAnalysis': () => $t({ defaultMessage: '评价分析' }),
  'main-operations-courierTemplate': () => $t({ defaultMessage: '快递模板' }),
  'main-operations-creditExchangeList': () => $t({ defaultMessage: '积分商城' }),
  'main-operations-crm': () => $t({ defaultMessage: '营销活动中心' }),
  'main-operations-customer-group': () => $t({ defaultMessage: '客户群体' }),
  'main-operations-customer-tag': () => $t({ defaultMessage: '客户标签' }),
  'main-operations-customers': () => $t({ defaultMessage: '客户列表' }),
  'main-operations-dataDefinition': () => $t({ defaultMessage: '数据定义' }),
  'main-operations-deposit': () => $t({ defaultMessage: '储值体系' }),
  'main-operations-discountedBuying': () => $t({ defaultMessage: '优惠买单' }),
  'main-operations-discountPackage': () => $t({ defaultMessage: '优惠券包' }),
  'main-operations-discounts': () => $t({ defaultMessage: '优惠券' }),
  'main-operations-discountSetting': () => $t({ defaultMessage: '折扣减免' }),
  'main-operations-douyinCoupon': () => $t({ defaultMessage: '抖音团购券' }),
  'main-operations-downPayment': () => $t({ defaultMessage: '订金/押金' }),
  'main-operations-eblocation': () => $t({ defaultMessage: '淘宝闪购·零售门店列表' }),
  'main-operations-ebmanager': () => $t({ defaultMessage: '淘宝闪购·零售授权管理' }),
  'main-operations-ebproduct': () => $t({ defaultMessage: '淘宝闪购·零售门店商品' }),
  'main-operations-elmlocation': () => $t({ defaultMessage: '淘宝闪购·餐饮门店列表' }),
  'main-operations-elmmanager': () => $t({ defaultMessage: '淘宝闪购·餐饮授权管理' }),
  'main-operations-elmproduct': () => $t({ defaultMessage: '淘宝闪购·餐饮门店商品' }),
  'main-operations-employeeBillingManagement': () => $t({ defaultMessage: '个人挂账管理' }),
  'main-operations-equipmentSettings': () => $t({ defaultMessage: '设备管理' }),
  'main-operations-equityCard': () => $t({ defaultMessage: '权益卡' }),
  'main-operations-evaluationGift': () => $t({ defaultMessage: '评价有礼' }),
  'main-operations-evaluationSettings': () => $t({ defaultMessage: '评价设置' }),
  'main-operations-examine': () => $t({ defaultMessage: '商品审核' }),
  'main-operations-EXPBoard': () => $t({ defaultMessage: '效期看板' }),
  'main-operations-EXPCollect': () => $t({ defaultMessage: '效期汇总' }),
  'main-operations-fileSettings': () => $t({ defaultMessage: '素材中心' }),
  'main-operations-friendFission': () => $t({ defaultMessage: '好友裂变' }),
  'main-operations-fullGifts': () => $t({ defaultMessage: '满赠' }),
  'main-operations-fullReduce': () => $t({ defaultMessage: '满减满折' }),
  'main-operations-funGame': () => $t({ defaultMessage: '趣味竞猜' }),
  'main-operations-generalSettings': () => $t({ defaultMessage: '店铺信息' }),
  'main-operations-getDiscount': () => $t({ defaultMessage: '领券活动' }),
  'main-operations-giftBirthday': () => $t({ defaultMessage: '生日有礼' }),
  'main-operations-giftCard': () => $t({ defaultMessage: '礼品卡' }),
  'main-operations-giftConsume': () => $t({ defaultMessage: '消费有礼' }),
  'main-operations-giftDeposit': () => $t({ defaultMessage: '储值活动' }),
  'main-operations-giftLevel': () => $t({ defaultMessage: '升级有礼' }),
  'main-operations-giftSignIn': () => $t({ defaultMessage: '签到有礼' }),
  'main-operations-goods-collections': () => $t({ defaultMessage: '菜品系列' }),
  'main-operations-goods-cornerMark': () => $t({ defaultMessage: '角标' }),
  'main-operations-goods-detailLogInventory': () => $t({ defaultMessage: '库存变动' }),
  'main-operations-goods-goodsAttribute': () => $t({ defaultMessage: '菜品属性' }),
  'main-operations-goods-inventory': () => $t({ defaultMessage: '菜品库存' }),
  'main-operations-goods-mustOrderProduct': () => $t({ defaultMessage: '必点菜' }),
  'main-operations-goods-planInventory': () => $t({ defaultMessage: '计划库存' }),
  'main-operations-goods-productionDepartment': () => $t({ defaultMessage: '出品部门' }),
  'main-operations-goods-productLog': () => $t({ defaultMessage: '菜品日志' }),
  'main-operations-goods-productPrintConfig': () => $t({ defaultMessage: '菜品打印配置' }),
  'main-operations-goods-productSort': () => $t({ defaultMessage: '商品排序' }),
  'main-operations-goods-timePeriodMenu': () => $t({ defaultMessage: '时段菜单' }),
  'main-operations-goods-storeTimePeriodMenu': () => $t({ defaultMessage: '门店时段菜单' }),
  'main-operations-goods-productTimePeriod': () => $t({ defaultMessage: '菜品时段' }),
  'main-operations-goods-productUnit': () => $t({ defaultMessage: '单位' }),
  'main-operations-goods-stockSync': () => $t({ defaultMessage: '库存同步' }),
  'main-operations-goods-storeAttribute': () => $t({ defaultMessage: '门店菜品属性' }),
  'main-operations-groupBuying': () => $t({ defaultMessage: '拼团' }),
  'main-operations-groupRelay': () => $t({ defaultMessage: '群接龙' }),
  'main-operations-income-subject': () => $t({ defaultMessage: '收入科目' }),
  'main-operations-jdlocation': () => $t({ defaultMessage: '京东秒送门店列表' }),
  'main-operations-jdmanager': () => $t({ defaultMessage: '京东秒送授权管理' }),
  'main-operations-jdproduct': () => $t({ defaultMessage: '京东秒送门店商品' }),
  'main-operations-kdsDeviceManagement': () => $t({ defaultMessage: 'KDS设备管理' }),
  'main-operations-kdsSettings': () => $t({ defaultMessage: 'KDS设置' }),
  'main-operations-kitchenRules': () => $t({ defaultMessage: '后厨出品档口' }),
  'main-operations-koubeiCoupon': () => $t({ defaultMessage: '口碑团购券' }),
  'main-operations-kuaishouCoupon': () => $t({ defaultMessage: '快手团购券' }),
  'main-operations-alipayStore': () => $t({ defaultMessage: '支付宝门店' }),
  'main-operations-alipayStoreCoupon': () => $t({ defaultMessage: '管理门店团购券' }),
  'main-operations-alipayCoupon': () => $t({ defaultMessage: '支付宝神券' }),
  'main-operations-locationCopy': () => $t({ defaultMessage: '门店复制' }),
  'main-operations-luckyDraw': () => $t({ defaultMessage: '抽奖有礼' }),
  'main-operations-mallSetting': () => $t({ defaultMessage: '商城设置' }),
  'main-operations-manageCrm': () => $t({ defaultMessage: '营销活动管理' }),
  'main-operations-managePromotion': () => $t({ defaultMessage: '促销活动管理' }),
  'main-operations-markUpPurchase': () => $t({ defaultMessage: '加价购' }),
  'main-operations-meituanCoupon': () => $t({ defaultMessage: '美团团购券' }),
  'main-operations-member-price': () => $t({ defaultMessage: '会员价' }),
  'main-operations-metaField': () => $t({ defaultMessage: '元字段' }),
  'main-operations-mtlocation': () => $t({ defaultMessage: '美团外卖门店列表' }),
  'main-operations-mtproduct': () => $t({ defaultMessage: '美团外卖门店商品' }),
  'main-operations-mtsglocation': () => $t({ defaultMessage: '美团闪购门店列表' }),
  'main-operations-mtsgproduct': () => $t({ defaultMessage: '美团闪购门店商品' }),
  'main-operations-newCustomerExclusive': () => $t({ defaultMessage: '新客专享' }),
  'main-operations-notifySettings': () => $t({ defaultMessage: '消息通知' }),
  'main-operations-operatingParameter': () => $t({ defaultMessage: '业务开关与设置' }),
  'main-operations-operatingParameter-log': () => $t({ defaultMessage: '系统日志' }),
  'main-operations-orderComment': () => $t({ defaultMessage: '订单评价' }),
  'main-operations-payTypeSetting': () => $t({ defaultMessage: '支付方式' }),
  'main-operations-pickUpDistributionOrder': () => $t({ defaultMessage: '自提配送订单' }),
  'main-operations-platformlocation': () => $t({ defaultMessage: '平台小程序门店列表' }),
  'main-operations-point': () => $t({ defaultMessage: '积分体系' }),
  'main-operations-popUpCoupons': () => $t({ defaultMessage: '弹窗发券' }),
  'main-operations-pos-product': () => $t({ defaultMessage: 'POS门店套餐商品' }),
  'main-operations-posPrintSetting': () => $t({ defaultMessage: '票据样式设置' }),
  'main-operations-posPrintSort': () => $t({ defaultMessage: '打印顺序' }),
  'main-operations-posRemark': () => $t({ defaultMessage: '常用备注' }),
  'main-operations-preDeposit': () => $t({ defaultMessage: '预储值' }),
  'main-operations-printerManagement': () => $t({ defaultMessage: '打印机管理' }),
  'main-operations-printingBusiness': () => $t({ defaultMessage: '打印业务' }),
  'main-operations-product-dynamic-price': () => $t({ defaultMessage: '定时变价' }),
  'main-operations-product-release': () => $t({ defaultMessage: '菜品下发' }),
  'main-operations-product-template': () => $t({ defaultMessage: '菜谱模板' }),
  'main-operations-productAppointmentOrder': () => $t({ defaultMessage: '商品预约单' }),
  'main-operations-productMallOrder': () => $t({ defaultMessage: '商城订单' }),
  'main-operations-promotion': () => $t({ defaultMessage: '促销活动中心' }),
  'main-operations-questionnaireSurvey': () => $t({ defaultMessage: '问卷调查' }),
  'main-operations-queueSettings': () => $t({ defaultMessage: '排队设置' }),
  'main-operations-randomFullReduce': () => $t({ defaultMessage: '随机立减' }),
  'main-operations-receiptOfDepositary': () => $t({ defaultMessage: '寄存单' }),
  'main-operations-recommendAddPurchase': () => $t({ defaultMessage: '推荐加购' }),
  'main-operations-recommendProduct': () => $t({ defaultMessage: '推荐菜品' }),
  'main-operations-reduceFreight': () => $t({ defaultMessage: '减运费' }),
  'main-operations-RFMAnalysis': () => $t({ defaultMessage: 'RFM分析' }),
  'main-operations-salesman': () => $t({ defaultMessage: '销售员' }),
  'main-operations-scanOrder': () => $t({ defaultMessage: '买单订单' }),
  'main-operations-screenSetting': () => $t({ defaultMessage: '辅屏设置' }),
  'main-operations-secondHalf': () => $t({ defaultMessage: '满X件Y折' }),
  'main-operations-sendDiscount': () => $t({ defaultMessage: '精准营销' }),
  'main-operations-serviceFee': () => $t({ defaultMessage: '服务费' }),
  'main-operations-settings-locations': () => $t({ defaultMessage: '门店管理' }),
  'main-operations-sharedMutex': () => $t({ defaultMessage: '共享互斥' }),
  'main-operations-sitDownOrder': () => $t({ defaultMessage: '堂食订单' }),
  'main-operations-smsGroupSend': () => $t({ defaultMessage: '短信群发' }),
  'main-operations-smsTemplate': () => $t({ defaultMessage: '短信模板' }),
  'main-operations-staffManagement': () => $t({ defaultMessage: '员工管理' }),
  'main-operations-staffRole': () => $t({ defaultMessage: '员工角色' }),
  'main-operations-stagepositionSettings': () => $t({ defaultMessage: '台位管理' }),
  'main-operations-storageCondition': () => $t({ defaultMessage: '储存条件' }),
  'main-operations-tableOrder': () => $t({ defaultMessage: '桌台预订' }),
  'main-operations-tagRules': () => $t({ defaultMessage: '标签出品档口' }),
  'main-operations-takeout-product': () => $t({ defaultMessage: '外卖菜品下发' }),
  'main-operations-taskActivity': () => $t({ defaultMessage: '任务活动' }),
  'main-operations-templateType': () => $t({ defaultMessage: '模板类型' }),
  'main-operations-thirdOrder': () => $t({ defaultMessage: '三方平台订单' }),
  'main-operations-tiktoklocation': () => $t({ defaultMessage: '抖音外卖门店列表' }),
  'main-operations-tiktokmanager': () => $t({ defaultMessage: '抖音外卖授权管理' }),
  'main-operations-tiktokproduct': () => $t({ defaultMessage: '抖音外卖门店商品' }),
  'main-operations-tiktokselflocation': () => $t({ defaultMessage: '抖音自助核销门店列表' }),
  'main-operations-tiktokselfmanager': () => $t({ defaultMessage: '抖音自助核销授权管理' }),
  'main-operations-tiktokselfproduct': () => $t({ defaultMessage: '抖音自助核销门店商品' }),
  'main-operations-timeLimitDiscount': () => $t({ defaultMessage: '限时折扣' }),
  'main-operations-tvScreenDevice': () => $t({ defaultMessage: 'TV屏设备' }),
  'main-operations-tvSettings': () => $t({ defaultMessage: 'TV屏装修' }),
  'main-operations-userManagement': () => $t({ defaultMessage: '用户管理' }),
  'main-operations-userPortrait': () => $t({ defaultMessage: '用户画像' }),
  'main-operations-userRole': () => $t({ defaultMessage: '用户角色' }),
  'main-operations-validity': () => $t({ defaultMessage: '效期商品' }),
  'main-operations-vip': () => $t({ defaultMessage: '会员体系' }),
  'main-operations-vouchers': () => $t({ defaultMessage: '抵用券管理' }),
  'main-operations-weapp-adviceFeedbacks': () => $t({ defaultMessage: '建议反馈' }),
  'main-operations-weapp-decorateNavigation': () => $t({ defaultMessage: '小程序管理' }),
  'main-operations-weapp-miniprogram': () => $t({ defaultMessage: '授权设置' }),
  'main-operations-weapp-popularize': () => $t({ defaultMessage: '小程序推广' }),
  'main-operations-weapp-product': () => $t({ defaultMessage: '门店套餐商品' }),
  'main-operations-weapp-public': () => $t({ defaultMessage: '微信公众号' }),
  'main-operations-weapp-userAgreement': () => $t({ defaultMessage: '用户协议' }),
  'main-operations-wecom-accountManage': () => $t({ defaultMessage: '员工接口管理' }),
  'main-operations-wecom-application': () => $t({ defaultMessage: '应用' }),
  'main-operations-wecom-channelCodeList': () => $t({ defaultMessage: '渠道活码' }),
  'main-operations-wecom-customerGroupList': () => $t({ defaultMessage: '客户群' }),
  'main-operations-wecom-customerGroupSends': () => $t({ defaultMessage: '客户群发' }),
  'main-operations-wecom-customerList': () => $t({ defaultMessage: '客户列表' }),
  'main-operations-wecom-customerTag': () => $t({ defaultMessage: '标签管理' }),
  'main-operations-wecom-groupCodeList': () => $t({ defaultMessage: '社群活码' }),
  'main-operations-wecom-groupOwnerList': () => $t({ defaultMessage: '群主管理' }),
  'main-operations-wecom-groupSendAssistant': () => $t({ defaultMessage: '群发助手' }),
  'main-operations-wecom-groupTag': () => $t({ defaultMessage: '社群标签' }),
  'main-operations-wecom-groupwelcommessage': () => $t({ defaultMessage: '群欢迎语' }),
  'main-operations-wecom-lbsFriendList': () => $t({ defaultMessage: 'LBS加好友' }),
  'main-operations-wecom-lbsGroupList': () => $t({ defaultMessage: 'LBS引流入群' }),
  'main-operations-wecom-massGroupSends': () => $t({ defaultMessage: '社群群发' }),
  'main-operations-wecom-materialLibrary': () => $t({ defaultMessage: '素材库' }),
  'main-operations-wecom-overView': () => $t({ defaultMessage: '企微概览' }),
  'main-operations-wecom-roleManage': () => $t({ defaultMessage: '企微角色管理' }),
  'main-operations-wecom-staffList': () => $t({ defaultMessage: '员工管理' }),
  'main-report-busincess-analysis-report': () => $t({ defaultMessage: '营业概览' }),
  'main-report-business-beyond-statistic': () => $t({ defaultMessage: '营业外统计' }),
  'main-report-business-collection-reconciliation': () => $t({ defaultMessage: '营业收款稽核' }),
  'main-report-business-detail-report': () => $t({ defaultMessage: '营业明细' }),
  'main-report-business-discount-report': () => $t({ defaultMessage: '营业优惠分析' }),
  'main-report-business-income-discount-report': () => $t({ defaultMessage: '收入优惠统计' }),
  'main-report-business-payment-report': () => $t({ defaultMessage: '营业收入构成' }),
  'main-report-business-receipt-detail': () => $t({ defaultMessage: '营业收款明细' }),
  'main-report-business-receipt-statistics': () => $t({ defaultMessage: '营业收款统计' }),
  'main-report-business-refund-statistic': () => $t({ defaultMessage: '营业退款统计' }),
  'main-report-business-statistics-report': () => $t({ defaultMessage: '营业统计' }),
  'main-report-business-target-report': () => $t({ defaultMessage: '营业指标同环比' }),
  'main-report-card-sales-detail': () => $t({ defaultMessage: '卡券销售明细' }),
  'main-report-cashier-statistics': () => $t({ defaultMessage: '收银员统计' }),
  'main-report-category-sales-ranking-report': () => $t({ defaultMessage: '类别销售排行' }),
  'main-report-channel-business-statistics-report': () => $t({ defaultMessage: '渠道营业统计' }),
  'main-report-clear-sale-report': () => $t({ defaultMessage: '商品沽清统计' }),
  'main-report-consumption-analysis': () => $t({ defaultMessage: '小程序分析' }),
  'main-report-coupon-template-analysis': () => $t({ defaultMessage: '券模板分析' }),
  'main-report-ticket-package-sale-statistics': () => $t({ defaultMessage: '券包销售统计' }),
  'main-report-customer-card-trade-log': () => $t({ defaultMessage: '会员卡交易流水' }),
  'main-report-customer-consume-analysis': () => $t({ defaultMessage: '储值消费店间结算' }),
  'main-report-customer-consume-ratio': () => $t({ defaultMessage: '会员消费占比' }),
  'main-report-customer-deduction-report': () => $t({ defaultMessage: '会员扣款记录' }),
  'main-report-customer-performance': () => $t({ defaultMessage: '用户业绩' }),
  'main-report-customer-price-report': () => $t({ defaultMessage: '客单分析' }),
  'main-report-zero-sales-product-report': () => $t({ defaultMessage: '零销量菜品统计' }),
  'main-report-product-association-recommendation': () => $t({ defaultMessage: '菜品关联推荐' }),
  'main-report-promotion-effect-analysis': () => $t({ defaultMessage: '促销活动效果分析' }),
  'main-report-marketing-activity-effect-analysis': () =>
    $t({ defaultMessage: '营销活动效果分析' }),
  'main-report-customer-repurchase': () => $t({ defaultMessage: '会员复购汇总' }),
  'main-report-customer-repurchase-product': () => $t({ defaultMessage: '会员商品复购' }),
  'main-report-customer-stored-value-report': () => $t({ defaultMessage: '会员储值明细' }),
  'main-report-deposit-activity-effect-analysis': () => $t({ defaultMessage: '储值活动效果分析' }),
  'main-report-deposit-report': () => $t({ defaultMessage: '储值分析' }),
  'main-report-deposite-payment-method-detail': () => $t({ defaultMessage: '储值支付方式明细' }),
  'main-report-equity-card-stat': () => $t({ defaultMessage: '权益卡分析' }),
  'main-report-express-mall-statistics': () => $t({ defaultMessage: '快递商城统计' }),
  'main-report-feed-sale-statistics-report': () => $t({ defaultMessage: '加料销售统计' }),
  'main-report-gift-card-analysis': () => $t({ defaultMessage: '卡模板分析' }),
  'main-report-gift-card-balance-log': () => $t({ defaultMessage: '礼品卡明细' }),
  'main-report-gift-statistics-report': () => $t({ defaultMessage: '赠品统计' }),
  'main-report-group-purchase-coupon-record': () => $t({ defaultMessage: '团购券核销记录' }),
  'main-report-kit-sales-ranking-report': () => $t({ defaultMessage: '套餐销售统计' }),
  'main-report-mall-traffic-overview-report': () => $t({ defaultMessage: '商城流量概况' }),
  'main-report-method-statistics-report': () => $t({ defaultMessage: '做法统计' }),
  'main-report-platform-order-report': () => $t({ defaultMessage: '三方订单分析' }),
  'main-report-point-analysis-report': () => $t({ defaultMessage: '积分分析' }),
  'main-report-product-cost-gross': () => $t({ defaultMessage: '商品成本毛利' }),
  'main-report-product-location-sales-report': () => $t({ defaultMessage: '商品门店销售汇总' }),
  'main-report-product-marketing-report': () => $t({ defaultMessage: '商品营销统计' }),
  'main-report-product-overview-report': () => $t({ defaultMessage: '商品概览' }),
  'main-report-product-sales-details-report': () => $t({ defaultMessage: '商品销售明细' }),
  'main-report-product-sales-ranking-report': () => $t({ defaultMessage: '商品销售排行' }),
  'main-report-product-sales-summary-report': () => $t({ defaultMessage: '商品销售汇总' }),
  'main-report-product-summary-statistics': () => $t({ defaultMessage: '商品汇总' }),
  'main-report-return-product-statistics-report': () => $t({ defaultMessage: '退菜/退货统计' }),
  'main-report-sales-consumption': () => $t({ defaultMessage: '原材料销售消耗报表' }),
  'main-report-salesperson-statistics-report': () => $t({ defaultMessage: '销售员统计' }),
  'main-report-sensitive-operation-report': () => $t({ defaultMessage: '敏感操作统计' }),
  'main-report-service-fee-statistics': () => $t({ defaultMessage: '服务费统计' }),
  'main-report-session-business-statistics-report': () => $t({ defaultMessage: '餐/时段营业统计' }),
  'main-report-session-product-statistics-report': () => $t({ defaultMessage: '餐/时段商品统计' }),
  'main-report-shift-handover-statistics': () => $t({ defaultMessage: '交班统计' }),
  'main-report-sign-payment-detail': () => $t({ defaultMessage: '挂账明细' }),
  'main-report-deposit-pledge-statistics': () => $t({ defaultMessage: '订金/押金统计' }),
  'main-report-table-business-statistics-report': () => $t({ defaultMessage: '餐区/台位营业统计' }),
  'main-report-third-party-reconciliation-calendar': () => $t({ defaultMessage: '对账日历' }),
  'main-report-third-party-reconciliation-result-detail': () =>
    $t({ defaultMessage: '对账结果明细' }),
  'main-report-third-party-reconciliation-result-summary': () =>
    $t({ defaultMessage: '对账结果汇总' }),
  'main-report-ticket-income-statistics-report': () => $t({ defaultMessage: '券收入统计' }),
  'main-report-vip-card-operate-analysis': () => $t({ defaultMessage: '会员卡操作明细' }),
  'main-report-vip-data-report': () => $t({ defaultMessage: '会员概览' }),
  'main-serviceMarket-equityAccountList': () => $t({ defaultMessage: '权益账户' }),
  'main-serviceMarket-expenseOrder': () => $t({ defaultMessage: '费用订单' }),
  'main-serviceMarket-invoice': () => $t({ defaultMessage: '发票管理' }),
  'main-serviceMarket-invoiceDetail': () => $t({ defaultMessage: '发票管理' }),
  'main-serviceMarket-lemonServices': () => $t({ defaultMessage: '服务市场' }),
  'main-serviceMarket-lezhiMyPurchase': () => $t({ defaultMessage: '我的订购' }),
  'main-serviceMarket-messageDetail': () => $t({ defaultMessage: '短信' }),
  'main-serviceMarket-platformOrderSync': () => $t({ defaultMessage: '平台订单同步' }),
  'main-serviceMarket-storeAccountSettings': () => $t({ defaultMessage: '门店账户设置' }),
  'main-serviceMarket-temporaryPosPoint': () => $t({ defaultMessage: '授权点数管理' }),
  'process-manager-report': () => $t({ defaultMessage: '生产报表' }),
  'product-mall': () => $t({ defaultMessage: '商城商品' }),
  'product-product-category': () => $t({ defaultMessage: '菜品分类' }),
  'product-product-category-location': () => $t({ defaultMessage: '门店菜品分类' }),
  'product-standard': () => $t({ defaultMessage: '菜品库' }),
  'product-standard-location': () => $t({ defaultMessage: '门店菜品管理' }),
  'purchasing-manager-report': () => $t({ defaultMessage: '采购报表' }),
  refuse: () => $t({ defaultMessage: '404' }),
  'stock-accounting-periods': () => $t({ defaultMessage: '会计期' }),
  'stock-accounting-settlementManager': () => $t({ defaultMessage: '结转管理' }),
  'stock-check-adjustmentOrder': () => $t({ defaultMessage: '库存调整' }),
  'stock-check-adjustmentReason': () => $t({ defaultMessage: '库存调整原因' }),
  'stock-check-checkOrder': () => $t({ defaultMessage: '库存盘点' }),
  'stock-check-inventoryLossOrder': () => $t({ defaultMessage: '商品报损' }),
  'stock-check-transfer': () => $t({ defaultMessage: '库存转仓' }),
  'stock-cost-adjustment': () => $t({ defaultMessage: '库存成本调整' }),
  'stock-cost-recalculate': () => $t({ defaultMessage: '库存成本重算' }),
  'stock-document-completeItem': () => $t({ defaultMessage: '成套件管理' }),
  'stock-document-costCard': () => $t({ defaultMessage: '成本卡' }),
  'stock-document-itemCornerLabel': () => $t({ defaultMessage: '物品角标' }),
  'stock-document-itemFile': () => $t({ defaultMessage: '物品档案' }),
  'stock-document-priceLogs': () => $t({ defaultMessage: '物品改价记录' }),
  'stock-document-queryTemplate': () => $t({ defaultMessage: '物品查询模板' }),
  'stock-document-storehouseFile': () => $t({ defaultMessage: '仓库档案' }),
  'stock-document-virtualItem': () => $t({ defaultMessage: '虚拟物品' }),
  'stock-earth-innerApplyOrder': () => $t({ defaultMessage: '内部申请单' }),
  'stock-earth-locationReplenishment': () => $t({ defaultMessage: '要货单' }),
  'stock-earth-transferInOrder': () => $t({ defaultMessage: '调入单' }),
  'stock-earth-transferOutOrder': () => $t({ defaultMessage: '调出单' }),
  'stock-finance-costProject': () => $t({ defaultMessage: '费用项目' }),
  'stock-finance-distributionSettlement': () => $t({ defaultMessage: '配送结算' }),
  'stock-finance-locationDealings': () => $t({ defaultMessage: '门店往来账款' }),
  'stock-finance-locationExpense': () => $t({ defaultMessage: '门店费用' }),
  'stock-finance-locationFee': () => $t({ defaultMessage: '门店费用汇总' }),
  'stock-finance-locationPrepayment': () => $t({ defaultMessage: '门店预收' }),
  'stock-finance-locationPrepaymentSum': () => $t({ defaultMessage: '门店预收汇总' }),
  'stock-finance-supplierDealings': () => $t({ defaultMessage: '供应商往来账款' }),
  'stock-finance-supplierExpense': () => $t({ defaultMessage: '供应商费用' }),
  'stock-finance-supplierExpenseSummary': () => $t({ defaultMessage: '供应商费用汇总' }),
  'stock-finance-supplierPrepayment': () => $t({ defaultMessage: '供应商预付' }),
  'stock-finance-supplierPrepaymentSum': () => $t({ defaultMessage: '供应商预付汇总' }),
  'stock-finance-supplierSettlement': () => $t({ defaultMessage: '供应商结算' }),
  'stock-item-rule': () => $t({ defaultMessage: '仓库物品规则' }),
  'stock-order-exceedDiscountOrder': () => $t({ defaultMessage: '超量折扣' }),
  'stock-order-innerApplyOrder': () => $t({ defaultMessage: '内部申请单' }),
  'stock-order-innerReturnReason': () => $t({ defaultMessage: '退货申请原因' }),
  'stock-order-orderingControl': () => $t({ defaultMessage: '门店订货控制' }),
  'stock-order-productLocationPrice': () => $t({ defaultMessage: '物品配送价' }),
  'stock-order-productLocationProp': () => $t({ defaultMessage: '物品配送属性' }),
  'stock-order-productPurchaseProp': () => $t({ defaultMessage: '物品采购属性' }),
  'stock-order-purchaseTemplate': () => $t({ defaultMessage: '采购模板' }),
  'stock-order-replenishment-guide': () => $t({ defaultMessage: '补货向导' }),
  'stock-order-requestOrder': () => $t({ defaultMessage: '要货单' }),
  'stock-order-requestTemplate': () => $t({ defaultMessage: '要货模板' }),
  'stock-order-shipNet': () => $t({ defaultMessage: '配送网络' }),
  'stock-order-transferInOrder': () => $t({ defaultMessage: '调入单' }),
  'stock-order-transferOutOrder': () => $t({ defaultMessage: '调出单' }),
  'stock-process-labelPrinting': () => $t({ defaultMessage: '标签打印' }),
  'stock-process-locationProcessOrder': () => $t({ defaultMessage: '门店加工单' }),
  'stock-process-operator': () => $t({ defaultMessage: '作业人员' }),
  'stock-process-processProducts': () => $t({ defaultMessage: '加工品管理' }),
  'stock-process-productionBoard': () => $t({ defaultMessage: '生产看板' }),
  'stock-process-productionOrder': () => $t({ defaultMessage: '生产任务单' }),
  'stock-process-productionPlan': () => $t({ defaultMessage: '生产计划单' }),
  'stock-process-productionProcess': () => $t({ defaultMessage: '生产领料单' }),
  'stock-process-productionStorage': () => $t({ defaultMessage: '生产入库单' }),
  'stock-process-taskDashBoard': () => $t({ defaultMessage: '加工间任务看板' }),
  'stock-process-template': () => $t({ defaultMessage: '生产模板' }),
  'stock-purchase-directOrder': () => $t({ defaultMessage: '供应商直发单' }),
  'stock-purchase-purchaseOrder': () => $t({ defaultMessage: '采购订单' }),
  'stock-purchase-receiveOrder': () => $t({ defaultMessage: '采购收货' }),
  'stock-purchase-returnOrder': () => $t({ defaultMessage: '退货单' }),
  'stock-purchase-smart': () => $t({ defaultMessage: '采购向导' }),
  'stock-purchase-supplier': () => $t({ defaultMessage: '供应商' }),
  'stock-purchase-supplierUser': () => $t({ defaultMessage: '供应商用户' }),
  'stock-purchase-supplierUserRole': () => $t({ defaultMessage: '供应商用户角色' }),
  'stock-purchase-supplierWechatUnbind': () => $t({ defaultMessage: '供应商微信解绑' }),
  'stock-purchase-supply': () => $t({ defaultMessage: '物品供货关系' }),
  'stock-report-customerItemsSalesQuery': () => $t({ defaultMessage: '客户物品销售查询' }),
  'stock-report-directOrderDetails': () => $t({ defaultMessage: '供应商直发明细表' }),
  'stock-report-distributionGrossProfit': () => $t({ defaultMessage: '配送毛利分析表' }),
  'stock-report-entryExitDetails': () => $t({ defaultMessage: '库存进出明细' }),
  'stock-report-entryExitSummary': () => $t({ defaultMessage: '库存进出汇总' }),
  'stock-report-entryStockSummary': () => $t({ defaultMessage: '入库汇总' }),
  'stock-report-exitStockSummary': () => $t({ defaultMessage: '出库汇总' }),
  'stock-report-expectedYieldReport': () => $t({ defaultMessage: '应产率报表' }),
  'stock-report-goodsInventory': () => $t({ defaultMessage: '物品库存' }),
  'stock-report-inventoryTurnoverRate': () => $t({ defaultMessage: '库存周转率' }),
  'stock-report-inventoryWarn': () => $t({ defaultMessage: '库存预警' }),
  'stock-report-locationGrossProfit': () => $t({ defaultMessage: '门店毛利分析表' }),
  'stock-report-locationGrossProfitDiff': () => $t({ defaultMessage: '门店商品毛利对比表' }),
  'stock-report-materialAnalysisReport': () => $t({ defaultMessage: '加工品原料耗用分析表' }),
  'stock-report-processStaffReport': () => $t({ defaultMessage: '生产人员生产汇总表' }),
  'stock-report-processSummaryReport': () => $t({ defaultMessage: '生产汇总表' }),
  'stock-report-productCostDetail': () => $t({ defaultMessage: '商品成本明细表' }),
  'stock-report-productGrossProfit': () => $t({ defaultMessage: '商品毛利分析表' }),
  'stock-report-profitLossReport': () => $t({ defaultMessage: '损益统计表' }),
  'stock-report-purchaseMonitor': () => $t({ defaultMessage: '采购订单监控' }),
  'stock-report-purchaseSummaryDetails': () => $t({ defaultMessage: '采购汇总明细' }),
  'stock-report-requestOrderStatusList': () => $t({ defaultMessage: '要货单提交状态表' }),
  'stock-report-statisticsOfChange': () => $t({ defaultMessage: '进销存变动统计' }),
  'stock-report-stockInterrupt': () => $t({ defaultMessage: '断货分析' }),
  'stock-report-transferReportsTrack': () => $t({ defaultMessage: '配送跟踪' }),
  'stock-report-transiGoods': () => $t({ defaultMessage: '物品在途' }),
  'stock-settings-appProductSetting': () => $t({ defaultMessage: 'APP物品列表配置' }),
  'stock-settings-base': () => $t({ defaultMessage: '供应链参数' }),
  'stock-settings-couplerSettings': () => $t({ defaultMessage: '零售供应链设置' }),
  'stock-settings-couplerSettings-authorization': () => $t({ defaultMessage: '授权设置' }),
  'stock-settings-couplerSettings-earthLocation': () => $t({ defaultMessage: '门店列表' }),
  'stock-settings-couplerSettings-productSync': () => $t({ defaultMessage: '商品同步' }),
  'stock-settings-couplerSettings-retailSupplyChainSetting': () =>
    $t({ defaultMessage: '零售供应链设置' }),
  'stock-settings-couplerSettings-transferOrder': () => $t({ defaultMessage: '单据日志' }),
  'stock-settings-locationCopy': () => $t({ defaultMessage: '供应链门店复制' }),
  'stock-settings-printTemplate': () => $t({ defaultMessage: '打印模板设置' }),
  'stock-wholesale-customer': () => $t({ defaultMessage: '客户档案' }),
  'stock-wholesale-quote-order': () => $t({ defaultMessage: '销售报价单' }),
  'stock-wholesale-return-order': () => $t({ defaultMessage: '销售退货单' }),
  'stock-wholesale-sale-order': () => $t({ defaultMessage: '销售发货单' }),
  'stock-kingdee-branchBind': () => $t({ defaultMessage: '门店绑定' }),
  'stock-kingdee-productSync': () => $t({ defaultMessage: '商品同步' }),
  'stock-document-itemReplace': () => $t({ defaultMessage: '替代品管理' }),
};

export const getAliveTabRouteLabel = (route?: RouteLike) => {
  const routeName = route?.name;
  const routePath = typeof route?.path === 'string' ? route.path : undefined;

  if (routeName && routePath) {
    const titleGetter = routeTitleByNameAndPath[`${routeName}@${routePath}`];
    if (titleGetter) {
      return titleGetter();
    }
  }

  if (routeName) {
    const titleGetter = routeTitleByName[routeName];
    if (titleGetter) {
      return titleGetter();
    }
  }

  return route?.microApp || routeName || routePath || '';
};
